export default "__VITE_PUBLIC_ASSET__981d38f4__"